(function(){
  "use strict";

  /* ============================================================
     Looops Duft-Finder — Logik der Section "duft-finder".

     Die Daten kommen aus dem Theme: sections/duft-finder.liquid
     schreibt sie als JSON in ein <script type="application/json">.
     Hier steht nur, WIE ausgewaehlt wird, nicht WAS es gibt.

     Aus den Metaobjekten kommen live: Wirkung, Duftnoten, Duftprofil,
     Essenzen, Zweizeiler, Preise, Bilder, Links und Verfuegbarkeit.
     Im Code bleiben die Fragetexte und die Formatketten - also das,
     was redaktionell abgestimmt ist und sich selten aendert.
     ============================================================ */

  var wurzel = document.querySelector("[data-duft-finder]");
  if(!wurzel) return;

  /* Ausgangszustand der transparenten Kopfzeile merken, bevor render()
     das Attribut das erste Mal entfernt. */
  if(wurzel.hasAttribute("allow-transparent-header")) wurzel.dataset.transparent = "1";

  var quelle = wurzel.querySelector("[data-duft-finder-daten]");
  var DATEN;
  try {
    DATEN = JSON.parse(quelle.textContent);
  } catch(e){
    /* Ohne Daten bleibt die Seite leer statt halb aufgebaut. */
    return;
  }

  var SHOP      = DATEN.shop || "";
  var DUEFTE    = DATEN.duefte || [];
  var BILD      = DATEN.bilder || {};
  var TEXT      = DATEN.texte || {};
  var BENEFIT   = TEXT.benefit || {};
  var SAISON    = DATEN.saison || "weihnachten";

  /* Geschenkboxen. Der Finder kennt sie nicht als Duefte, sondern als
     Behaelter: jede Box weiss, welche Duefte in ihr stecken. Daraus bauen
     wir die Rueckrichtung Duft -> Box, denn danach wird gefragt. */
  var BOXEN = DATEN.boxen || {};
  var BOX_VON_DUFT = {};
  Object.keys(BOXEN).forEach(function(h){
    (BOXEN[h].duefte || []).forEach(function(id){ BOX_VON_DUFT[id] = h; });
  });

  /* Greift nur, wenn das Feld im Theme-Editor leer geraeumt wurde. */
  var FALLBACK_LEAD = "<p>Manche Düfte machen den Kopf frei.</p>" +
    "<p>Andere lassen den Tag leiser werden.</p>" +
    "<p>Für <em>dich</em> oder liebe Menschen.</p>";

  var BILD_START              = BILD.start || "";
  var BILD_START_MOBIL        = BILD.startMobil || BILD.start || "";
  var BILD_ERGEBNIS           = BILD.ergebnis || "";
  var BILD_ERGEBNIS_WEIHNACHTEN = BILD.ergebnisWeihnachten || BILD.ergebnis || "";
  var BILD_FRAGE    = BILD.frage || {};
  var BILD_GESCHENK = BILD.geschenk || {};

  /* ---- Fragen und Antworten: Konzept Abschnitt 1, 2, 5, 6 ---- */
  var WIRKUNGEN = {
    balance:     {kurz:"In Balance", name:"Balance", q4tipp:"winterzeit",      label:"In Balance – ausgeglichen, in meiner Mitte",     gift:"Balance – einen Moment im Gleichgewicht",     einstieg:"bergluft"},
    energie:     {kurz:"Voller Energie", name:"Energie", q4tipp:null,  label:"Voller Energie – wach und frisch",               gift:"Energie – einen wachen, frischen Start",    einstieg:"gebirgsbach"},
    entspannung: {kurz:"Entspannt", name:"Entspannung", q4tipp:"abendgold",       label:"Entspannt – ruhig und gelöst",                   gift:"Entspannung – Ruhe nach einem langen Tag",  einstieg:"mussezeit"},
    erdung:      {kurz:"Geerdet", name:"Erdung", q4tipp:"stille",         label:"Geerdet – verbunden und gestärkt",               gift:"Erdung – Halt und Verbundenheit",           einstieg:"waldruhe"},
    frohsinn:    {kurz:"Voller Frohsinn", name:"Frohsinn", q4tipp:"sternenzelt", label:"Voller Frohsinn – leicht, ganz unbeschwert",     gift:"Frohsinn – Leichtigkeit, ganz unbeschwert", einstieg:"sonnenstund"}
  };
  var WIRK_ORDER = ["balance","energie","entspannung","erdung","frohsinn"];

  var NOTEN = {
    "frisch":        {kurz:"Frisch",        sub:"wie Zitrone und Bergamotte"},
    "blumig":        {kurz:"Blumig",        sub:"wie Lavendel und Rosengeranie"},
    "krautig":       {kurz:"Krautig",       sub:"wie Rosmarin und Salbei"},
    "waldig-holzig": {kurz:"Waldig-holzig", sub:"wie Zirbe und Tanne"},
    "warm-würzig":   {kurz:"Warm-würzig",   sub:"wie Zimt und Orange"}
  };
  var NOTE_ORDER = ["frisch","blumig","krautig","waldig-holzig","warm-würzig"];

  var MOMENTE = {
    morgens:      {label:"Morgens",          sub:"für einen wachen Start",                erst:"raumspray",   auch:["staebchen","kerze-klein"]},
    /* Duftstaebchen greifen nur, wenn es den Raumspray nicht gibt - die Kette
       nimmt die ersten zwei vorhandenen Formate. */
    schreibtisch: {label:"Am Schreibtisch",  sub:"zwischen Aufgaben und Gedanken",        erst:"aeris",       auch:["raumspray","staebchen"]},
    /* Daheim wechselt pro Duftblock zwischen zwei Paaren, damit auch die grosse
       Duftkerze vorkommt: 1., 3. ... Duft Staebchen + Quint, 2., 4. ... Duft
       grosse Kerze + Staebchen. erst/auch sind die Vereinigung beider Paare -
       fehlt ein Format beim Duft, rueckt das naechste daraus nach.
       rang = feste Reihenfolge der Karten statt Preis: Kerze vor Staebchen
       vor Quint - auch wenn ein Format nachgerueckt ist. */
    daheim:       {label:"Daheim",           sub:"umgeben von Vertrautem",                erst:"staebchen",   auch:["quint","kerze-gross"],
                   wechsel:[["staebchen","quint"],["kerze-gross","staebchen"]],
                   rang:["kerze-gross","staebchen","quint"]},
    unterwegs:    {label:"Unterwegs",        sub:"im Hotel oder auf Reisen",              erst:"aeris",       auch:["raumspray-klein","kerze-klein"]},
    abends:       {label:"Abends",           sub:"wenn der Tag leiser wird",              erst:"kerze-gross", auch:["mehrdocht","quint"]},
    /* Mit Kissenspray: Kissenspray + Duftstaebchen, ohne: Duftstaebchen + Quint.
       rang haelt die Reihenfolge fest, links steht immer das Hauptformat. */
    einschlafen:  {label:"Beim Einschlafen", sub:"als sanfter Übergang in die Nacht",     erst:"kissenspray", auch:["staebchen","quint"],
                   rang:["kissenspray","staebchen","quint"]}
  };
  var MOMENT_ORDER = ["morgens","schreibtisch","daheim","unterwegs","abends","einschlafen"];

  /* sub = zeitlos, subW = weihnachtlich. Der Schalter tauscht nur den Text. */
  var GESTEN = {
    klein:     {label:"Eine kleine Aufmerksamkeit", fest:true,
                sub:"Zum Mitbringen oder einfach so",
                subW:"Zum Mitbringen fürs Fest",
                formate:["kerze-klein","raumspray-klein","oel"]},
    geschenk:  {label:"Eine schöne Geste", fest:true,
                sub:"Für einen Anlass, der etwas bedeutet",
                subW:"Ein Weihnachtsgeschenk mit Sinn",
                formate:["kerze-gross","staebchen"]},
    besonders: {label:"Etwas Besonderes",
                sub:"Wenn es in Erinnerung bleiben darf",
                subW:"Wenn Weihnachten in Erinnerung bleibt",
                formate:["quint","mehrdocht","aeris"]}
  };
  var GESTE_ORDER = ["klein","geschenk","besonders"];

  /* Nutzenversprechen je Format. Der Formatname steht bereits als Subheading
     ueber der Zeile, deshalb hier ohne Namensvorsatz - sonst stuende er doppelt
     und die Zeile passte nicht mehr ohne Umbruch in die Karte. */

  /* ---------- Hilfen ---------- */
  /* "Am Schreibtisch" darf nicht mitten in der Wortgruppe umbrechen. Jede
     Gruppe steht in einem eigenen nowrap-Span, der Trenner haengt an der
     Gruppe davor - so bricht die Zeile nur zwischen den Gruppen. */
  function teile(liste){
    return liste.map(function(t, i){
      return '<span class="nobr">' + esc(t) + (i < liste.length - 1 ? ' ·' : '') + '</span>';
    }).join(" ");
  }

  /* Shopify liefert Rich-Text-Felder als JSON, nicht als HTML - beim Rendern
     ueber Liquid kam die rohe Struktur auf der Seite an. Deshalb hier die
     Umwandlung: Absaetze fallen weg (wir setzen ein eigenes <p>), Zeilen-
     umbrueche werden zu <br>, Kursives zu <i> (die CSS-Regel haengt an i). */
  function richText(roh){
    if(!roh) return "";
    /* Liquid liefert das Feld mal als JSON-Text, mal schon als Objekt -
       beides abfangen, sonst steht "[object Object]" auf der Seite. */
    var wurzel;
    if(typeof roh === "object"){
      wurzel = roh;
    } else {
      try { wurzel = JSON.parse(roh); }
      catch(e){ return esc(String(roh)); }
    }
    if(!wurzel || !wurzel.children) return "";
    function knoten(n){
      if(n.type === "text"){
        var t = esc(n.value || "").replace(/\n/g, "<br>");
        if(n.bold) t = "<strong>" + t + "</strong>";
        if(n.italic) t = "<i>" + t + "</i>";
        return t;
      }
      return (n.children || []).map(knoten).join("");
    }
    return (wurzel.children || []).map(knoten).join("");
  }

  function collUrl(d){ return d.url || (SHOP + "/collections/" + d.id); }
  function esc(s){
    return String(s).replace(/[&<>"]/g, function(c){
      return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];
    });
  }
  function gross(t){ return t ? t.charAt(0).toUpperCase() + t.slice(1) : t; }

  /* Tracking-Schluessel aus dem Antwortwert: snake_case in ASCII, wie im
     Storefinder (TAG_TRACK_KEYS). "warm-würzig" wird zu "warm_wuerzig",
     "waldig-holzig" zu "waldig_holzig" - Umlaute und Bindestriche kommen
     in GTM und GA4 nicht verlaesslich an. */
  function trackKey(v){
    return String(v).toLowerCase()
      .replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss")
      .replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  }

  var state = {};

  /* Saison des Geschenkpfads. Im Theme eine Section-Einstellung, damit
     niemand Texte nachpflegen muss. */
  function weihnachten(){ return state.saison !== "zeitlos"; }

  /* Alle Duefte, auch die Limited Editions. Nicht lieferbare Produkte
     stehen gar nicht erst in den Daten. */
  function pool(){ return DUEFTE.slice(); }

  function notenFuer(w){
    var s = {};
    pool().forEach(function(d){ if(d.wirkung===w) d.noten.forEach(function(n){ s[n]=1; }); });
    return NOTE_ORDER.filter(function(n){ return s[n]; });
  }
  function q2Entfaellt(){ return state.wirkung && notenFuer(state.wirkung).length <= 1; }

  /* Reihenfolge im Ergebnis: Limited Editions zuerst, darin die laufende
     Winteredition vorne. Alles andere behaelt seine Reihenfolge aus DUEFTE. */
  var VORRANG = ["stille"];   // innerhalb der Limited Editions zuerst

  function vorreihen(list){
    return list.slice().sort(function(a, b){
      /* Ein einzelnes Produkt traegt keinen Block - solche Duefte stehen
         unten, auch wenn sie sonst vorgereiht waeren (betrifft Stille). */
      var ka = kette(a).length > 1, kb = kette(b).length > 1;
      if(ka !== kb) return ka ? -1 : 1;
      if(a.le !== b.le) return a.le ? -1 : 1;
      var ia = VORRANG.indexOf(a.id), ib = VORRANG.indexOf(b.id);
      if(ia < 0) ia = VORRANG.length;
      if(ib < 0) ib = VORRANG.length;
      return ia - ib;
    });
  }

  function treffer(){
    var w = state.wirkung, ns = state.noten, p = pool();
    if(!w) return [];
    if(ns.indexOf("ueberrasch") >= 0 || ns.indexOf("unsicher") >= 0){
      /* Einstiegsduft der Wirkung, dazu der Saisonduft - sobald es ihn gibt.
         Das haengt an der Verfuegbarkeit, nicht am Textschalter: die Winterduefte
         stehen ab Ende August im Regal, die weihnachtliche Ansprache startet
         spaeter. Faellt der Bestand auf null, verschwindet er von selbst. */
      var ids = [WIRKUNGEN[w].einstieg];
      if(WIRKUNGEN[w].q4tipp) ids.push(WIRKUNGEN[w].q4tipp);
      var e = p.filter(function(d){ return ids.indexOf(d.id) >= 0 && kette(d).length > 0; });
      if(!e.length) e = p.filter(function(d){ return d.id === WIRKUNGEN[w].einstieg; });
      /* Auch hier steht die Limited Edition vorn - in beiden Textmodi,
         weihnachtlich wie zeitlos. Der Einstiegsduft folgt. */
      return vorreihen(e.sort(function(x, y){ return ids.indexOf(x.id) - ids.indexOf(y.id); }));
    }
    /* Vereinigung, nicht Schnittmenge: ein Duft reicht, wenn er EINE der Noten hat. */
    var treffer = p.filter(function(d){
      if(d.wirkung !== w) return false;
      if(!ns.length) return true;
      return ns.some(function(n){ return d.noten.indexOf(n) >= 0; });
    });
    /* Duefte ohne lieferbares Produkt fuer diesen Weg fallen raus - sonst stuende
       ein leerer Block da, womoeglich noch vorgereiht. Faellt alles weg, bleibt
       die ungefilterte Liste, damit die Seite nie leer ist. */
    var mitProdukt = treffer.filter(function(d){ return kette(d).length > 0; });
    return vorreihen(mitProdukt.length ? mitProdukt : treffer);
  }

  /* Formatkette: Erstvorschlag, dann Alternativen - nur was es beim Duft gibt.
     nr = Position des Duftblocks im Ergebnis; nur fuer Momente mit "wechsel"
     relevant. Ohne nr (Filtern, Sortieren) zaehlt die volle Kette. */
  function kette(d, nr){
    var chain;
    if(state.gift){
      chain = ((GESTEN[state.geste] || {}).formate || []).slice();
      /* "Etwas Besonderes" ohne Mehrdochtkerze: Refill-Set und Aeris statt Quint. */
      if(state.geste === "besonders" && !d.produkte["mehrdocht"]){
        chain = ["set-kerze", "aeris"];
      }
    } else {
      var m = MOMENTE[state.moment] || {};
      chain = [ m.erst ].concat(m.auch || []);
      if(m.wechsel && typeof nr === "number"){
        chain = m.wechsel[nr % m.wechsel.length].concat(chain);
      }
    }
    var seen = {}, out = [];
    chain.forEach(function(f){
      if(!f || seen[f]) return;
      seen[f] = 1;
      /* Was hier steht, ist bereits lieferbar und keine B-Ware - das
         filtert sections/duft-finder.liquid heraus. */
      if(d.produkte[f]) out.push(f);
    });
    return out;
  }

  function schritte(){
    var s = [];
    if(state.vorschalterAn) s.push("vorschalter");
    s.push("wirkung");
    if(!q2Entfaellt()) s.push("note");
    s.push(state.gift ? "geste" : "moment");
    return s;
  }
  function aktuell(){ var s = schritte(); return s[Math.min(state.schritt, s.length-1)]; }

  /* ---------- Render ---------- */
  var app = wurzel.querySelector("[data-duft-finder-app]");

  /* behalten=true: die Scrollposition bleibt stehen. Das gilt fuer jede Auswahl
     innerhalb einer Frage - wer eine Antwort weiter unten antippt, soll nicht
     an den Seitenanfang zurueckgerissen werden. Ein echter Schrittwechsel
     (weiter, zurueck, Ergebnis) beginnt dagegen oben. */
  function render(behalten){
    var y = window.scrollY;
    /* app.innerHTML wird gleich ersetzt - das Klaviyo-Embed vorher heraus-
       holen, sonst ist es weg und laesst sich nicht neu befuellen. */
    var depot = wurzel.querySelector("[data-duft-finder-klaviyo]");
    if(depot && depot.parentNode !== wurzel) wurzel.appendChild(depot);
    if(state.schritt < 0){ app.innerHTML = startHtml(); bindStart(); }
    else {
      var s = schritte();
      if(state.schritt >= s.length){ app.innerHTML = resultHtml(); bindResult(); }
      else { app.innerHTML = frageHtml(aktuell(), s); bindFrage(); }
    }
    /* Die transparente Kopfzeile gilt nur fuer den Startbildschirm. Danach
       laege sie ueber Creme und waere nicht lesbar. Das Attribut steht im
       Liquid, hier wird es nur entfernt und zurueckgegeben. */
    if(state.schritt < 0){
      if(wurzel.dataset.transparent === "1") wurzel.setAttribute("allow-transparent-header", "");
    } else if(wurzel.hasAttribute("allow-transparent-header")){
      wurzel.dataset.transparent = "1";
      wurzel.removeAttribute("allow-transparent-header");
    }

    /* Klick-Tracking: der gewaehlte Weg (Frage 1) haengt am Bereich und wird
       von GTM fuer jeden Klick darin mitgelesen - so laesst sich jede Antwort
       nach "fuer mich" und "zum Verschenken" trennen. Vor der Wahl und nach
       dem Neustart kein Wert. */
    if(state.giftWahl) wurzel.setAttribute("data-track-purpose", state.giftWahl === "schenken" ? "gift" : "self");
    else wurzel.removeAttribute("data-track-purpose");

    window.scrollTo(0, behalten ? y : 0);
    scrollHinweis();
  }

  function startHtml(){
    return '<section class="start" style="--hero:url(' + BILD_START + ');--hero-mobil:url(' + BILD_START_MOBIL + ')">' +
      '<div class="start-inner">' +
        '<h1>Finde deine Essenz.</h1>' +
        /* Einleitung kommt als Rich Text aus der Section. Jeder Absatz ist
           eine Zeile - die Absatzabstaende nimmt duft-finder.css heraus. */
        '<div class="start-lead">' + (TEXT.startLead || FALLBACK_LEAD) + '</div>' +
        '<button class="btn btn-light" type="button" data-go data-track-event="duftfinder_start">Starten</button>' +
      '</div></section>';
  }

  function bildFuer(key){
    if(state.gift && BILD_GESCHENK[key]) return BILD_GESCHENK[key];
    return BILD_FRAGE[key] || BILD_START;
  }

  function frageHtml(key, alle){
    var nr = alle.indexOf(key) + 1, ges = alle.length;
    var head, hint, opts, multi = false, gewaehlt = [];

    if(key === "vorschalter"){
      head = "Für dich – oder zum Verschenken?";
      hint = "So finden wir Düfte, die wirklich passen.";
      if(state.giftWahl) gewaehlt = [state.giftWahl];
      opts = [
        {v:"selbst",   main:"Für mich",        sub:"Ein Duft für meinen Alltag"},
        {v:"schenken", main:"Zum Verschenken",
         sub: weihnachten() ? "Ein Duft für Weihnachten" : "Ein Duft für einen lieben Menschen"}
      ];
    } else if(key === "wirkung"){
      if(state.giftWahl === "schenken"){
        head = "Was möchtest du schenken?";
        hint = "Beginne bei dem, was guttun könnte.";
      } else {
        head = "Wie möchtest du dich fühlen?";
        hint = "Beginne bei dem, was dein Moment gerade braucht.";
      }
      if(state.wirkung) gewaehlt = [state.wirkung];
      opts = WIRK_ORDER.map(function(w){
        var lab = (state.giftWahl === "schenken" ? WIRKUNGEN[w].gift : WIRKUNGEN[w].label).split(" – ");
        return {v:w, main:lab[0], sub:lab[1] || ""};
      });
    } else if(key === "note"){
      if(state.giftWahl === "schenken"){
        head = "Kennst du die Duftvorlieben?";
        hint = "Wähle bis zu zwei Duftnoten, die gut passen könnten.";
      } else {
        head = "Was riechst du gern?";
        hint = "Wähle bis zu zwei Duftnoten, die dich besonders ansprechen.";
      }
      multi = true;
      gewaehlt = state.noten.slice();
      /* Alle fuenf Noten zeigen. Die, die es fuer die gewaehlte Wirkung nicht
         gibt, bleiben sichtbar und sagen in der zweiten Zeile warum. */
      var da = notenFuer(state.wirkung);
      opts = NOTE_ORDER.map(function(n){
        var frei = da.indexOf(n) >= 0;
        return {
          v:n,
          main:NOTEN[n].kurz,
          sub: frei ? NOTEN[n].sub : "Für deine gewählte Stimmung nicht verfügbar",
          aus: !frei
        };
      });
      opts.push(state.giftWahl === "schenken"
        ? {v:"unsicher",   main:"Ich bin mir nicht sicher",  sub:"Wir wählen einen Duft, der gut passen könnte."}
        : {v:"ueberrasch", main:"Ich lass mich überraschen", sub:"Wir wählen einen Duft, der gut passen könnte."});
    } else if(key === "moment"){
      head = "Wie darf Duft dich begleiten?";
      hint = "Daraus ergibt sich das passende Format.";
      if(state.moment) gewaehlt = [state.moment];
      opts = MOMENT_ORDER.map(function(m){ return {v:m, main:MOMENTE[m].label, sub:MOMENTE[m].sub}; });
    } else {
      head = "Wie groß soll die Geste sein?";
      hint = weihnachten()
        ? "Wähle, was zum Fest und zur Person passt."
        : "Wähle, was gut zum Anlass und zur Person passt.";
      if(state.geste) gewaehlt = [state.geste];
      opts = GESTE_ORDER.map(function(g){
        return {v:g, main:GESTEN[g].label, sub: weihnachten() ? GESTEN[g].subW : GESTEN[g].sub};
      });
    }

    /* Nicht verfuegbare Antworten rutschen ans Ende der Liste. Sie bleiben
       sichtbar und begruendet, unterbrechen aber nicht mehr die waehlbaren.
       Stabil sortiert: untereinander behalten beide Gruppen ihre Reihenfolge. */
    opts = opts.filter(function(o){ return !o.aus; })
      .concat(opts.filter(function(o){ return o.aus; }));

    var exklusiv = gewaehlt.indexOf("ueberrasch") >= 0 || gewaehlt.indexOf("unsicher") >= 0;
    var voll = multi && !exklusiv && gewaehlt.length >= 2;

    /* Der Zaehler steht unter der Einleitung, im selben Satz wie sie -
       oben rechts als Versalzeile war er eine zweite Stimme. */
    /* Klick-Tracking: gemessen wird am Weiter-Button, nicht an den Kacheln -
       so zaehlt nur die Antwort, mit der es tatsaechlich weitergeht. Das
       Event haengt an der Frage, nicht an ihrer Nummer: entfaellt die
       Notenfrage, rueckt die Formatfrage auf Platz 3 und bleibt trotzdem
       duftfinder_format. Ohne Auswahl kein Event (Button ist gesperrt). */
    var TRACK_FRAGE = {vorschalter:"duftfinder_anlass", wirkung:"duftfinder_wirkung",
                       note:"duftfinder_note", moment:"duftfinder_format", geste:"duftfinder_format"};
    var track = "";
    if(gewaehlt.length){
      /* Nach dem Tracking-Schluessel sortieren, die Titel folgen derselben
         Reihenfolge - Wert und Text passen so immer zueinander. */
      var werte = gewaehlt.slice().sort(function(a, b){
        return trackKey(a) < trackKey(b) ? -1 : trackKey(a) > trackKey(b) ? 1 : 0;
      });
      var titel = werte.map(function(v){
        var o = opts.filter(function(x){ return x.v === v; })[0];
        return o ? o.main : v;
      });
      track = ' data-track-event="' + TRACK_FRAGE[key] + '"' +
        ' data-track-filter-value="' + esc(werte.map(trackKey).join(",")) + '"' +
        ' data-track-element-text="' + esc(titel.join(" + ")) + '"';
    }

    var zaehler = multi ? '<p class="q-zaehler">' + gewaehlt.length + ' von 2 gewählt</p>' : '';
    var rolle = multi ? "checkbox" : "radio";

    return '<section class="split">' +
      '<div class="pane-img" style="background-image:url(' + bildFuer(key) + ')" role="presentation"></div>' +
      '<div class="pane-q">' +
        /* Nur mobil sichtbar: eine Strecke je Frage, erledigte gefuellt.
           Ersetzt das Bild als Orientierung, ohne Prozente zu behaupten. */
        '<div class="q-fortschritt" role="progressbar" aria-valuemin="1" aria-valuemax="' +
          ges + '" aria-valuenow="' + nr + '" aria-label="Frage ' + nr + ' von ' + ges + '">' +
          alle.map(function(_, i){
            return '<span' + (i < nr ? ' class="an"' : '') + '></span>';
          }).join("") +
        '</div>' +
        '<div class="q-block">' +
          '<div class="q-top"><span class="eyebrow">Frage ' + nr + ' von ' + ges + '</span></div>' +
          '<h1 class="q-title">' + esc(head) + '</h1>' +
          '<p class="q-hint">' + esc(hint) + '</p>' + zaehler +
        '</div>' +
        '<div class="alist" role="' + (multi ? "group" : "radiogroup") + '">' +
          opts.map(function(o){
            var an = gewaehlt.indexOf(o.v) >= 0;
            var terminal = (o.v === "ueberrasch" || o.v === "unsicher");
            /* Nur bei zwei gewaehlten Noten sperren. Die Ausweichantwort darf die
               Auswahl nicht einfrieren - ein Klick auf eine Note loest sie ab. */
            var sperre = o.aus || (multi && !an && voll && !terminal);
            return '<div class="aopt" data-val="' + esc(o.v) + '" role="' + rolle + '"' +
              ' aria-checked="' + (an ? "true" : "false") + '"' +
              (sperre ? ' aria-disabled="true"' : ' tabindex="0"') + '>' +
              '<span class="mark"></span><span class="aopt-txt">' +
              '<p class="aopt-main">' + esc(o.main) + '</p>' +
              (o.sub ? '<p class="aopt-sub' + (o.aus ? ' aopt-sub--aus' : '') + '">' + esc(gross(o.sub)) + '</p>' : '') +
              '</span></div>';
          }).join("") +
        '</div>' +
        '<div class="q-nav">' +
          '<button type="button" class="btn-plain" data-back>&larr; Zurück</button>' +
          '<button type="button" class="btn btn-primary" data-next' + track + ' ' + (gewaehlt.length ? "" : "disabled") + '>' +
            (nr === ges ? "Duft entdecken" : "Nächste Frage") + '</button>' +
        '</div>' +
      '</div></section>';
  }

  /* Produktkarte im Aufbau der Theme-Karte: Bild 4:5, Titelzeile mit Preis,
     Produktart als Subheading, Zutaten als Subtitle. */
  /* box gesetzt: die Karte zeigt die Geschenkbox statt des Einzelprodukts.
     Gleiche Bauform, nur andere Quelle, anderer Alt-Text und statt des
     Einzeilers die Duefte, die in der Box stecken. */
  function pcard(d, fmt, box){
    var e = (box ? box.produkte : d.produkte)[fmt];
    if(!e) return "";
    var titel = box ? box.name : d.name;
    /* Auf jeder Box-Karte steht in der zweiten Zeile, um welche Box es geht.
       Bei Quint und Aeris ist das noetig, weil es beide auch ohne Box und
       guenstiger gibt - sonst stuende dort "Quint Diffuser 159 EUR", wo der
       Duft-Quint 120 EUR kostet, und das liest sich wie ein Fehler. Die
       Boxen selbst tragen dieselbe Zeile, damit die Karten gleich sprechen. */
    var zeile = box ? ('mit \u201E' + box.kurz + '\u201C') : BENEFIT[fmt];
    var url = e.u;
    return '<a class="pcard" href="' + url + '" target="_blank" rel="noopener"' +
      ' data-track-event="duftfinder_product" data-track-element-text="' + esc(e.l) + '">' +
      '<div class="pcard__figure">' +
        /* srcset wie im Theme-Grid: ein fixes 520er Bild ist auf Retina und
           breiten Screens zu klein und wird hochskaliert (unscharf). */
        '<img src="' + esc(e.i) + '"' +
          (e.is ? ' srcset="' + esc(e.is) + '" sizes="(max-width: 699px) 50vw, 25vw"' : '') +
          ' alt="' + esc(titel + " – " + e.l) + '" loading="lazy">' +
        (e.le ? '<span class="badge">Limited Edition</span>' : '') +
        '<span class="pcard__quickbuy"><span class="btn">In den Warenkorb</span></span>' +
        /* Auf Touch zeigt das Theme statt des Buttons nur das Taschen-Icon
           unten rechts im Bild - gleiche Groesse, gleiches Icon. */
        '<span class="pcard__bag" aria-hidden="true">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none">' +
            '<path stroke-width="1.1" stroke="currentColor" d="m1.5 14.5 1-12h11l1 12h-13Z"></path>' +
            '<path stroke-width="1.1" stroke="currentColor" d="M5.5 5c.238.833 1.071 2.5 2.5 2.5s2.262-1.667 2.5-2.5"></path>' +
          '</svg></span>' +
      '</div>' +
      '<div class="pcard__info">' +
        /* Der Duftname steht schon als Ueberschrift ueber den Karten - auf der
           Karte waere er Wiederholung. Die Produktart unterscheidet die
           Karten voneinander und traegt deshalb die Zeile. */
        '<div class="pcard__titlerow">' +
          '<span class="pcard__title">' + esc(e.l) + '</span>' +
          /* notranslate: Weglot hat auf dem Shop schon Betraege zerlegt.
             Das Theme nimmt .price-list und .money aus, unsere Karte nutzt
             eine eigene Klasse und faellt da nicht drunter. */
          '<span class="pcard__price notranslate">' + esc(e.pt) + '</span>' +
        '</div>' +
        (zeile ? '<p class="pcard__benefit">' + esc(zeile) + '</p>' : '') +
      '</div></a>';
  }

  /* Welche Box gehoert zu diesem Duft - und darf sie hier ueberhaupt stehen? */
  function boxFuer(d){
    if(!state.gift || state.geste === "klein") return null;
    var h = BOX_VON_DUFT[d.id];
    var box = h ? BOXEN[h] : null;
    return (box && box.produkte) ? box : null;
  }

  function resultHtml(){
    var ds = treffer();
    var schenken = state.giftWahl === "schenken";
    var ueberrascht = state.noten.indexOf("ueberrasch") >= 0 || state.noten.indexOf("unsicher") >= 0;

    var basis = [WIRKUNGEN[state.wirkung].name];
    if(!ueberrascht) state.noten.forEach(function(n){ if(NOTEN[n]) basis.push(NOTEN[n].kurz); });
    if(state.moment) basis.push(MOMENTE[state.moment].label);
    if(state.geste)  basis.push(GESTEN[state.geste].label);
    /* Ohne Notenwahl steht statt der Note der Hinweis, wonach wir ausgewaehlt haben. */
    if(ueberrascht) basis.push("Beliebter Duft");

    /* Aufbau wie eine Collection-Seite: Subheading, Titel, h3-Zeile.
       Bei genau einem Treffer traegt der Kopf den Duft, sonst die Bloecke. */
    /* Nur Headline und die Basis-Zeile - die Einleitung ist auf allen Pfaden
       entfallen, sie sagte nichts, was die Auswahl nicht schon zeigt. */
    var kopf = '<header class="result-head">' +
      '<p class="eyebrow result-eyebrow">Deine Auswahl</p>' +
      (schenken
        ? (weihnachten()
            ? '<h1>Für Weihnachten <i>gefunden.</i></h1>'
            : '<h1>Gefunden, was <i>passt.</i></h1>')
        : '<h1>Für <i>dich</i> gefunden.</h1>') +
      '<p class="basis"><span class="basis-label">Basierend auf:</span>' + teile(basis) + '</p>' +
      /* Der Geschenkeservice gilt nur, wenn verschenkt wird - "mit
         persoenlichen Worten von dir" ergibt im Fuer-dich-Pfad keinen Sinn. */
      (state.gift && TEXT.geschenkservice
        /* Der Zeilenumbruch aus der Einstellung bleibt erhalten. Das
           Leerzeichen davor haelt den Wortabstand, wenn duft-finder.css das
           <br> auf dem Telefon ausblendet - dort bricht der Satz von selbst. */
        ? '<p class="gservice">' + esc(TEXT.geschenkservice).replace(/\n/g, " <br>") + '</p>' +
          (TEXT.geschenkserviceUrl && TEXT.geschenkserviceCta
            ? '<a class="gservice-cta" href="' + esc(TEXT.geschenkserviceUrl) + '"' +
              ' data-track-event="duftfinder_gift_service"' +
              ' target="_blank" rel="noopener">' + esc(TEXT.geschenkserviceCta) + '</a>'
            : '')
        : '') +
      '</header>';

    var bloecke = ds.map(function(d, nr){
      var k = kette(d, nr).slice(0, 2);
      /* Normalerweise nach Preis gestaffelt. Wo die Reihenfolge inhaltlich
         zaehlt (Geste "Ein Geschenk"), bleibt sie wie in der Kette; ein
         Moment mit "rang" (Daheim) sortiert nach dieser Liste. */
      var fest = state.gift && (GESTEN[state.geste] || {}).fest;
      var rang = !state.gift && (MOMENTE[state.moment] || {}).rang;
      if(rang){
        k = k.sort(function(a, b){ return rang.indexOf(a) - rang.indexOf(b); });
      } else if(!fest){
        k = k.sort(function(a, b){
          var pa = d.produkte[a], pb = d.produkte[b];
          return (pa ? pa.p : 0) - (pb ? pb.p : 0);
        });
      }
      var karten = k.map(function(f){ return pcard(d, f); }).filter(Boolean);

      /* Geschenkbox statt zweiter Karte. Nur im Geschenkpfad und nicht bei
         "Eine kleine Aufmerksamkeit" - dort liegt die Kette bei kleiner Kerze,
         kleinem Raumspray und Oel, eine Box ab 75 EUR waere daneben deplatziert.
         Gibt es die Box in genau dem Format, das weichen wuerde (Quint, Aeris),
         nehmen wir dieses; sonst die Duftkerzen-Box. */
      var box = boxFuer(d);
      if(box && karten.length === 2){
        var bfmt = box.produkte[k[1]] ? k[1] : (box.produkte["box-kerzen"] ? "box-kerzen" : null);
        if(bfmt){
          var bk = pcard(d, bfmt, box);
          if(bk) karten[1] = bk;
        }
      }

      var duftLink = '<div class="sblock-foot"><a class="btn btn-outline" href="' + collUrl(d) +
        '" target="_blank" rel="noopener" data-track-event="duftfinder_scent">Duft entdecken</a></div>';

      var inhalt = karten.length
        ? '<div class="pgrid">' + karten.join("") + '</div>' + duftLink
        : '<p class="basis">Für diesen Moment gibt es ' + esc(d.name) + ' derzeit kein passendes Format.</p>' + duftLink;

      /* Bei einem Treffer steht der Duft schon im Kopf - nicht doppelt nennen. */
      return '<section class="sblock">' +
        '<div class="sblock-head">' +
          /* notranslate: Duftnamen sind Produktnamen. Ohne das wird aus
             "Bergluft" ein "Mountain air" und aus "Stille" ein "Silence". */
          '<h2 class="sblock-name notranslate">' + esc(d.name) + '</h2>' +
          (d.zwei ? '<p class="sblock-poem">' + richText(d.zwei) + '</p>' : '') +
          /* Duftprofil aus dem Metaobjekt, mit Punkt am Ende. Ein bereits
             vorhandener Punkt wird nicht verdoppelt. */
          (d.profil
            ? '<p class="sblock-note">' + esc(gross(d.profil).replace(/\.*$/, "")) + '.</p>' : '') +
          (d.essenzen ? '<p class="sblock-ing">' + teile(d.essenzen.split(" · ")) + '</p>' : '') +
        '</div>' +
        '<div class="sblock-body">' + inhalt + '</div>' +
      '</section>';
    }).join("");

    /* Newsletter wie /pages/newsletter. Im Theme ersetzt das Klaviyo-Embed das
       Formular unten - ein leeres div mit der Klasse klaviyo-form-XQMUNT genuegt,
       das Klaviyo-Skript laedt das Theme bereits global (Konto UezT7a).
       Im Klickdummy kann Klaviyo nicht laden, deshalb hier nachgebaut.
       Achtung: in diesem Kommentar kein woertliches End-Tag eines Skripts -
       das beendet den Script-Block der Seite und kippt die Ausgabe in den Text. */
    /* Das echte Klaviyo-Embed. Das Skript laedt das Theme global, das leere
       div genuegt - Formular, Einwilligungstext und Absenden kommen von dort.
       Formular-ID XQMUNT, dieselbe wie auf /pages/newsletter. */
    var newsletter = '<section class="nl"><div class="nl-inner">' +
      '<h2 class="nl-claim">Ein guter <i>Anfang</i>.</h2>' +
      '<p class="nl-lead">Düfte, Gedanken, Neuigkeiten – direkt in dein Postfach. <br>' +
        'Dazu 10&nbsp;% für deine erste Bestellung.</p>' +
      '<div data-nl-slot></div>' +
    '</div></section>';

    /* Gleiches Raster wie die Fragen: Bild links (auf Desktop sticky),
       rechts der Inhalt - der scrollt an ihm vorbei. */
    var bild = (schenken && weihnachten()) ? BILD_ERGEBNIS_WEIHNACHTEN : BILD_ERGEBNIS;

    /* Neustart in derselben Form wie "Zurueck" auf den Fragen. */
    var neustart = '<div class="result-neu">' +
      '<button type="button" class="btn-plain" data-neu data-track-event="duftfinder_restart">&larr; Nochmal beginnen</button></div>';
    return '<section class="split">' +
      '<div class="pane-img" style="background-image:url(' + bild + ')" role="presentation"></div>' +
      '<div class="pane-result"><div class="result">' + kopf + bloecke + neustart + newsletter +
      '</div></div></section>';
  }

  /* ---------- Events ---------- */
  function bindStart(){
    app.querySelector("[data-go]").addEventListener("click", function(){ state.schritt = 0; render(); });
  }

  function bindFrage(){
    var key = aktuell();
    var multi = (key === "note");

    function waehle(v){
      if(multi){
        var terminal = (v === "ueberrasch" || v === "unsicher");
        var i = state.noten.indexOf(v);
        if(i >= 0){ state.noten.splice(i,1); }
        else if(terminal){ state.noten = [v]; }
        else {
          state.noten = state.noten.filter(function(x){ return x !== "ueberrasch" && x !== "unsicher"; });
          if(state.noten.length < 2) state.noten.push(v);
        }
      } else if(key === "vorschalter"){
        state.giftWahl = v; state.gift = (v === "schenken");
      } else if(key === "wirkung"){
        if(state.wirkung !== v) state.noten = [];
        state.wirkung = v;
      } else if(key === "moment"){ state.moment = v; }
      else { state.geste = v; }
      render(true);
    }

    app.querySelectorAll(".aopt").forEach(function(b){
      if(b.getAttribute("aria-disabled") === "true") return;
      b.addEventListener("click", function(){ waehle(b.getAttribute("data-val")); });
      b.addEventListener("keydown", function(e){
        if(e.key === " " || e.key === "Enter"){ e.preventDefault(); waehle(b.getAttribute("data-val")); }
      });
    });

    /* Weiter immer ueber den Button - kein automatischer Sprung. */
    app.querySelector("[data-next]").addEventListener("click", function(){
      state.schritt++; render();
    });
    app.querySelector("[data-back]").addEventListener("click", function(){
      state.schritt--;
      if(state.schritt < 0) state.schritt = -1;
      render();
    });
  }

  /* Das von Klaviyo befuellte Embed an seinen Platz im Newsletter-Block
     schieben. Es wird verschoben, nicht neu erzeugt - ein zweites leeres
     div wuerde Klaviyo nicht mehr finden. */
  function bindResult(){
    var depot = wurzel.querySelector("[data-duft-finder-klaviyo]");
    var platz = app.querySelector("[data-nl-slot]");
    if(depot && platz) platz.appendChild(depot);

    var neu = app.querySelector("[data-neu]");
    if(neu) neu.addEventListener("click", reset);
  }

  function reset(){
    state = {
      gift:false, schritt:-1,
      wirkung:null, noten:[], moment:null, geste:null,
      giftWahl:null, vorschalterAn:true,
      saison: SAISON
    };
    render();
  }

  /* Passen die Antworten nicht in den Viewport, verraet ein Verlauf ueber der
     Navigationsleiste, dass es weitergeht. Massgeblich ist die letzte Antwort,
     nicht das Seitenende - sonst blieb der Verlauf wegen des Footers stehen
     und graute die letzte Antwort aus, obwohl sie ganz zu sehen war. */
  function scrollHinweis(){
    var nav = app.querySelector(".q-nav");
    if(!nav) return;
    var letzte = app.querySelector(".alist .aopt:last-child");
    var mehr = !!letzte && letzte.getBoundingClientRect().bottom > nav.getBoundingClientRect().top + 1;
    nav.setAttribute("data-mehr", mehr ? "true" : "false");
  }
  window.addEventListener("scroll", scrollHinweis, {passive:true});
  window.addEventListener("resize", scrollHinweis);

  /* ---------- Herkunft merken ---------- */
  /* Wer aus dem Ergebnis auf eine Produktkarte klickt, bekommt den Handle
     in localStorage "looops_duftfinder" gemerkt: [{handle, ts}], Eintraege
     aelter als 30 Tage fliegen raus. Das Theme (ProductForm in theme.js)
     gibt beim In-den-Warenkorb-Legen dieses Produkts dann die unsichtbare
     Positions-Eigenschaft _quelle=duftfinder mit. auxclick fuer den
     Mittelklick, der die Karte ebenfalls in einem neuen Tab oeffnet. */
  var HERKUNFT_KEY = "looops_duftfinder";
  var HERKUNFT_MAX_ALTER = 30 * 24 * 60 * 60 * 1000;
  function herkunftMerken(ev){
    var a = ev.target.closest && ev.target.closest('a.pcard[data-track-event="duftfinder_product"]');
    if(!a) return;
    var treffer;
    try { treffer = new URL(a.getAttribute("href"), location.origin).pathname.match(/\/products\/([^\/]+)/); } catch(e){ return; }
    if(!treffer) return;
    var handle = decodeURIComponent(treffer[1]);
    var jetzt = Date.now();
    try {
      var liste = JSON.parse(localStorage.getItem(HERKUNFT_KEY) || "[]");
      if(!Array.isArray(liste)) liste = [];
      liste = liste.filter(function(x){
        return x && x.handle && x.handle !== handle && jetzt - x.ts < HERKUNFT_MAX_ALTER;
      });
      liste.push({ handle: handle, ts: jetzt });
      localStorage.setItem(HERKUNFT_KEY, JSON.stringify(liste));
    } catch(e){ /* localStorage gesperrt (privater Modus o. ae.) - dann eben ohne Markierung */ }
  }
  wurzel.addEventListener("click", herkunftMerken);
  wurzel.addEventListener("auxclick", herkunftMerken);

  /* ---------- Weglot ---------- */
  /* Weglot uebersetzt nachgeladenen Inhalt ueber einen MutationObserver auf
     .duft-finder-app (der Selektor steht im Weglot-Dashboard unter Dynamic
     Elements). Der erste Aufbau passiert aber, bevor dieser Beobachter haengt:
     Am 24.09.2026 war auf /en/ alles ab der ersten Frage englisch, nur der
     Startbildschirm blieb deutsch - ihm fehlte schlicht die Aenderung, auf die
     der Beobachter wartet.

     Sobald Weglot bereit ist, haengen wir den Inhalt deshalb einmal ab und
     wieder an. Das ist die Aenderung, die der Beobachter braucht; live
     geprueft, danach steht dort "Find your essence." statt "Finde deine
     Essenz.". Ohne Weglot oder in der Ausgangssprache passiert nichts. */
  function weglotAnstossen(versuche){
    var W = window.Weglot;
    if(!W || !W.initialized || !W.getCurrentLang){
      if(versuche > 0) setTimeout(function(){ weglotAnstossen(versuche - 1); }, 250);
      return;
    }
    if(W.options && W.getCurrentLang() === W.options.language_from) return;
    var kind = app.firstElementChild;
    if(kind){ app.removeChild(kind); app.appendChild(kind); }
  }

  reset();
  weglotAnstossen(40);   // hoechstens 10 Sekunden lang nachsehen
})();
